import { render, staticRenderFns } from "./SwitchCover.vue?vue&type=template&id=553d5d6c"
import script from "./SwitchCover.vue?vue&type=script&lang=js"
export * from "./SwitchCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports